import { createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import {
  KNOWLEDGE_BASE_EULA,
  KNOWLEDGE_BASE_PRIVACY_POLICY,
  KNOWLEDGE_BASE_TERMS_OF_USE,
} from 'features/help/constants';
import { FC } from 'react';
import { Link } from 'react-router-dom';

interface HelpFooterProps {
  isHomePage?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      alignItems: 'center',
      alignSelf: 'stretch',
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: 0,
      padding: theme.spacing(2, 3),
      width: '100%',
      zIndex: 1,
    },
    homeBg: {
      backgroundColor: theme.palette.brand.feather25,
    },
    centerArea: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
    },
    footerLinks: {
      alignItems: 'flex-start',
      display: 'flex',
      whiteSpace: 'nowrap',
    },
    separator: {
      color: theme.palette.divider,
      marginLeft: theme.spacing(1.5),
      marginRight: theme.spacing(1.5),
    },
    linkGrid: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  }),
);

export const HelpFooter: FC<HelpFooterProps> = ({ isHomePage }) => {
  const classes = useStyles();
  return (
    <Grid container className={clsx(classes.footer, { [classes.homeBg]: isHomePage })}>
      <Grid item md={6}>
        <Typography color="textSecondary" data-testid="kb-footer-copyright" variant="caption">
          &copy; {new Date().getFullYear()} AgentNet and/or its affiliates. All rights reserved.
        </Typography>
      </Grid>
      <Grid item md={3} className={classes.linkGrid}>
        <Typography data-testid="kb-footer-terms-and-privacy-links" className={classes.footerLinks} variant="body2">
          <Link to={KNOWLEDGE_BASE_EULA}>EULA</Link>
          <div className={classes.separator}>|</div>
          <a href={KNOWLEDGE_BASE_TERMS_OF_USE} target="_blank" rel="noreferrer">
            Terms of Use
          </a>
          <div className={classes.separator}>|</div>
          <a href={KNOWLEDGE_BASE_PRIVACY_POLICY} target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
        </Typography>
      </Grid>
    </Grid>
  );
};
